export class CitationActivityTypeEnum {
	public Issued: number = 1;         // Citation was issued.
	public Cancelled: number = 2;      // Citation was cancelled.
	public Appealed: number = 3;       // Citation was appealed.
	public Paid: number = 4;           // Citation was paid in full.
	public Commented: number = 5;      // A comment was added to citation.
	public Attached: number = 6;       // A file was attached to citation.
	public Searched: number = 7;       // Citation was searched for.
	public Viewed: number = 8;         // Citation was viewed.
	public Adjusted: number = 9;       // Citation fine amount was adjusted.
	public FeeAdded: number = 10;      // A processing fee was added.
	public PaymentMade: number = 11;   // A citation payment was made.
	public Refunded: number = 12;      // A citation payment was refunded.
	public Restored: number = 20;      // Citation status was restored to Outstanding.
	public Imported: number = 21;    //Citation was imported from external/legacy system.
	public Exported: number = 22;    //Citation was exported to external/legacy system.
	public Collections: number = 23;    //Citation was sent to a collections agency.
	public Modified: number = 24;    //Citation was modified by an external/legacy system.
	public GeneratedNotice: number = 25; //
	public OwnerInfoRequested: number = 26; //
	public OwnerInfoUpdated: number = 27; //
	public Opened: number = 300;       // A citation appeal was opened.
	public Reviewed: number = 301;     // A citation appeal was reviewed.
	public Rejected: number = 302;     // A citation appeal was rejected.
	public Accepted: number = 303;     // A citation appeal was accepted.
	public Held: number = 304;         // A citation appeal was put on hold.
	public Reopened: number = 305;     // Citation appeal was reopened.
	public Withdrawn: number = 306;    // Citation appeal was withdrawn.    
}

export class CitationStatusEnum{
	public OwnerInfo: number = 1;
	public NotPayable: number = 4;
	public Appealing: number = 8;
	public InAppeals: number = 8;
	public Outstanding: number = 16;
	public Paid: number = 64;
	public OnHold: number = 128;
	public Notices: number = 256;
	public Upheld: number = 512;
	public OwnerQueued: number = 599;
	public OwnerReady: number = 600;
	public NoOwner: number = 601;
	public Cancelled: number = 1024;
	public Refunded: number = 4096;
	public QueuedCollection: number = 8190;
	public RevenueCollection: number = 8192;
	public Warning   : number = 32768;
}

export class PermitStatusEnum {
	public Approved: number = 2;
	public Denied: number = 4;
	public InReview: number = 8;
	public New: number = 16;
	public Waitlisted: number = 32;
	public Paid: number = 64;
	public OnHold: number = 128;
	public Expired: number = 256;
	public Renewal: number = 512;
	public Renewed: number = 65536;
	public Cancelled: number = 1024;
	public Refunded: number = 4096;
}

export class EntitySourceEnum {
	public Permit: number = 1;            //Permit table
	public Owner: number = 2;             //Owner table
	public PermitType: number = 3;        //PermitType table
	public Client: number = 4;            //Client table
	public Application: number = 5;       //Application table
	public Vehicle: number = 6;           //Vehicle table
	public Account: number = 7;           //Account table
	public EnfArea: number = 8;           //Enforcement Area
	public Schedule: number = 9;          //Schedule table
	public Site: number = 10;             //A parking facility or location
	public Registration: number = 11;     //Registration table
	public Role: number = 12;             //Collection of application features and groups
	public Group: number = 13;            //Collection of roles and accounts
	public Feature: number = 14;          //Feature of an application. Task, option, ability
	public EnfGroup: number = 15;         //Zones of enforcement. Collection of Enforcement Areas
	public Token: number = 16;            //Token table
	public Configuration: number = 17;    //Client or Application configuration setting
	public ParkingEvent: number = 18;     //Enforcement Area Activity
	public Registrar: number = 19;     //Parking Space
	public VehiclePlate: number = 20;     //VehiclePlate
	public Device: number = 21;           //Hardware devices - Cameras, Handhelds, Pay Stations, etc.
	public Invoice: number = 22;          //Payment invoices
	public Citation: number = 23;         //Issued tickets, violations, PINs or citations
	public Violation: number = 24;        //Violation description
	public ParkingSpace: number = 25;
	public Order: number = 26;
	public License: number = 27;
	public LicensePackage: number = 28;
	public FormField: number = 29;
	public Transition: number = 30;
	public TraceLog: number = 31;
}

export class TransactionStatusEnum{
	public PendingApproval: number = 1;
	public Approved: number = 2;
	public Denied: number = 4;
	public New: number = 16;
	public Paid: number = 64;
	public Expired: number = 256;
	public Success: number = 600;
	public Fail: number = 601;
	public Refund: number = 602;
	public Cancelled: number = 1024;
	public RecurBilling: number = 2048;
	public Reversed: number = 4096;
	public Modified: number = 16384;
	public Warning: number = 32768;
	public VelocityVerified: number = 100;
}

export class DeviceTypeEnum {
	public PayStation: number = 1;
	public Camera: number = 2;
	public Handheld: number = 3;
	public Printer: number = 4;
	public Vehicle: number = 5;
	public Gate: number = 6;
	public Sensor: number = 7;
	public Notebook: number = 8;
	public Sign: number = 9;
	public Virtual: number = 100;
	public Unknown: number = 99;
}

export class AlertTypeEnum {
	public Abusive: string = "B90471B1-0B44-4687-A1AA-DCA264E72FB6";
	public Wanted: string = "27F72550-C574-4BBE-82C8-CB5FB859B8C1";
	public Exempt: string = "519BF4BA-675C-43C4-BCAB-869FC564641B";
}

export class ContactTypeEnum {

}

export class ViolationClassEnum {
	public Parking: number = 1;
	public Bylaw: number = 2;
	public Parking_Bylaw: number = 3;
}

export class SolutionTypeEnum {
	public Default: number = 0;
	public Hosted: number = 1;
	public iFrame: number = 2;
	public FullPage: number = 3;
}

export class ParkingEventStatusEnum {
	public Unpaid:number = 0;
	public EntryGrace:number = 1;
	public ExitGrace:number = 2;
	public PayByPhone:number = 3;
	public VPRS:number = 4;
	public PayByPdm:number = 5;
	public Permit:number = 6;
	public Staff:number = 7;
	public InvalidRate:number = 8;
	public Commuter:number = 9;
	public Resident:number = 10;
	public ExpiredCard:number = 11;
	public UnassignedCard:number = 12;
	public Overstay:number = 14;
	public Undefined: number = 15;
	public Empty: number = 16;
	public Guest: number = 17;
	public Registered: number = 101;
	public R:number = 100; // (Vehicle is not paid)
	public G:number = 101; // (Vehicle arrived at parking spot and is paid)
	public Y:number = 102; // (Vehicle arrived at parking spot, is paid but is now within expiry grace period)
	public C:number = 103; // (Vehicle arrived at parking spot, is not paid but is within payment grace period)
	public B:number = 104; // (Parking spot status is unknown)
	public E:number = 105; // (Parking spot is vacant)
	public P:number = 106; // (Parking spot is vacant but has valid paid parking)
	public A:number = 107; // (Parking spot is occupied and paid by resident card)
	public D:number = 108; // (Parking spot is paid with expired resident card)
	public X:number = 119; // (Parking spot is paid with deactivated/stolen resident card)
	public O:number = 110; // (Parking spot is paid, but user has overstayed)
}

export class ActivityTypeEnum {
	public PayStationPayment: number = 1;
	public KioskPayment: number = 2;
	public PaymentByPhone: number = 3;
	public SensorArrival: number = 4;
	public SensorDeparture: number = 5;
	public LprArrival: number = 6;
	public LprDeparture: number = 7;
	public VprsRegistration: number = 8;
	public VprsSheckout: number = 9;
	public CitationPayment: number = 10;
	public PaymentValidity: number = 11;
	public ManualAdjustment: number = 12;
	public ExpiryTimeManagement: number = 13;
	public PermitPayment: number = 14;
	public TokenReuse: number = 15;
	public TokenRefund: number = 16;
	public TokenUnuse: number = 17;
	public PeoManualArrival: number = 18;
	public PeoManualDeparture: number = 19;
	public UserManualArrival: number = 20;
	public UserManualDeparture: number = 21;
}

export class PaymentMethodEnum {
	public CashOrCoin: number = 0;
	public MoneyOrder: number = 1;
	public Cheque: number = 2;
	public NSFChq: number = 3;
	public Debit: number = 4;
	public Transfer: number = 5;
	public Correction: number = 6;
	public AMEX: number = 7;
	public MasterCard: number = 8;
	public Visa: number = 9;
	public OtherCreditCard: number = 10;
	public Realtime: number = 11;
	public Commuter: number = 12;
	public Resident: number = 13;
	public Comp: number = 14;
	public Token: number = 15;
	public Heartland: number = 16;
	public Unknown: number = 17;
	public Discovery: number = 18;
	public BillNote: number = 29;
	public NoPayment: number = 501;
	public CreditCardOnly: number = 502;
	public ManualPayment: number = 503;
}

export class PaymentTypeEnum
{
	public PDM: number = 1;
	public VPRS: number = 2;
	public Verrus: number = 3;
	public PkMob: number = 4;
	public Kiosk: number = 5;
	public HH: number = 6;
	public QuickPay: number = 7;
	public Passport: number = 8;
	public Lpr: number = 9;
	public Collections: number = 10;
	public ERP: number = 11;
	public Online: number = 12;
}

export class ChalkingTypeEnum
{
	public GEO: number = 1;
	public LOCALE: number = 2;
	public AREA: number = 3;
}

export class WorkflowTypeEnum
{
	public PermitRegistration :number = 1;
	public CitationNotices :number = 2;
	public CitationAppeals :number = 3;
	public CitationCollections :number = 4;
	public TowingIntegration :number = 5;
	public VehicleOwnerLookup  :number = 6;
}

export class ExportTypesEnum
{
	public FTP: number = 1;
	public Email: number = 2;
	public REST_API: number = 4;
	public SOAP_API: number = 5;
	public File: number = 8;
}

export class ParkingUnitTypeEnum
{
	public Day: number = 1;
	public Month: number = 2;
	public Hour: number = 3;
	public None: number = 4;
	public Fixed: number = 5;
	public Year: number = 6;
	public Minute: number = 7;
	public Week: number = 8;
	public CalendarWeek: number = 9;
	public CalendarMonth: number = 10;
	public CalendarYear: number = 11;
	public CalendarDay: number = 12;
}

export class CardProcessorTypeEnum
{
	public Unknown : number = 0;
	public PMT : number = 1;
	public Eigen : number = 2;
	public MonerisCA : number = 3;
	public MonerisUS : number = 4;
	public GlobalPayments : number = 5;
	public ChaseCAEXact : number = 6;
	public ChaseUSOrbital : number = 7;
	public AdvamAU : number = 8;
	public AuthorizeNet : number = 9;
	public FirstData : number = 10;
	public Elavon : number = 11;
	public OpenEdge : number = 12;
	public ChasePaymentech : number = 14;
	public Velocity : number = 15;
	public Heartland : number = 16;
	public EVOPayments : number = 17;
	public EVOSnap : number = 18;
	public MonerisCheckout : number = 19;
	public CyberSource : number = 20;
    public Fiserv : 21;
    public BankOfAmerica : 22;
    public ChasePNS : 23;
    public WorldPay : 24;
}

export class IntegratorTypeEnum
{
	public PayByPhone: number = 1;
	public HonkMobile: number = 2;
	public ICBC: number = 11;
	public Tempest: number = 12;
	public Atlas: number = 14;
	public Duncan: number = 15;
	public Wiggins: number = 16;
	public AMVIR: number = 17;
	public ARIS: number = 42;
}